import { jsx as _jsx } from "react/jsx-runtime";
import ImagesGalleryRowComponent from "components/core/images-gallery/images-gallery-row/images-gallery-row-component";
import { StyledBadgesGridDesktopComponent } from "./badges-grid-desktop-component.scss";
const BadgesGridDesktopComponent = ({ badges, horizontalPadding })=>{
    return /*#__PURE__*/ _jsx(StyledBadgesGridDesktopComponent, {
        horizontalPadding: horizontalPadding,
        className: "badges-grid-desktop-component",
        children: /*#__PURE__*/ _jsx(ImagesGalleryRowComponent, {
            assets: badges
        })
    });
};
export default BadgesGridDesktopComponent;
